export default __webpack_public_path__ + "static/media/bg-large-cyan.24481baa.svg";